import "./BodhiCategoryCard.css";

// Stable string hash so a category always maps to the same colour, regardless
// of its position in a (possibly randomised) list.
const hashString = (str) => {
	let hash = 0;
	for (let i = 0; i < (str || "").length; i++) {
		hash = (hash << 5) - hash + str.charCodeAt(i);
		hash |= 0;
	}
	return Math.abs(hash);
};

// Muted, spa-inspired palette — soft sage / earth tones that sit quietly
// against the app's calm theme. A category always maps to the same pair.
const SPA_GRADIENTS = [
	["#5e7d6f", "#445f4f"], // sage
	["#4f7e7a", "#39605d"], // teal
	["#5a7088", "#42556a"], // dusty blue
	["#8a6f63", "#6a5249"], // clay
	["#8a7d63", "#665b46"], // sand
	["#6f7d52", "#52603d"], // moss
	["#7d6b7a", "#5c505b"], // mauve
	["#6b756e", "#4f5853"], // stone
];

// Two-stop gradient derived from the category name.
const gradientFromName = (name) => {
	const [from, to] = SPA_GRADIENTS[hashString(name) % SPA_GRADIENTS.length];
	return `linear-gradient(135deg, ${from}, ${to})`;
};

/**
 * @param {string} [as] - element to render; pass "span" to nest it inside
 *   another button, which plain <button> nesting would make invalid HTML
 */
const BodhiCategoryCard = ({
	category,
	size = "default",
	active = false,
	onClick,
	as: Tag = "button",
	className = "",
	style,
	...rest
}) => {
	if (!category) return null;

	const name = category.name || "Untitled";
	const image = category.cover_image_url || category.image || null;
	const count =
		typeof category.albums_count === "number" ? category.albums_count : null;

	const cls = [
		"bodhi-category",
		size === "sm" && "bodhi-category-sm",
		size === "lg" && "bodhi-category-lg",
		active && "bodhi-category-active",
		className,
	]
		.filter(Boolean)
		.join(" ");

	return (
		<Tag
			type={Tag === "button" ? "button" : undefined}
			className={cls}
			style={{ "--cat-gradient": gradientFromName(name), ...style }}
			onClick={onClick}
			title={name}
			{...rest}
		>
			{image && (
				<img
					className="bodhi-category-img"
					src={image}
					alt=""
					loading="lazy"
					aria-hidden="true"
				/>
			)}
			<span className="bodhi-category-content">
				<span className="bodhi-category-name">{name}</span>
				{count !== null && (
					<span className="bodhi-category-count">
						{count} collection{count === 1 ? "" : "s"}
					</span>
				)}
			</span>
		</Tag>
	);
};

export default BodhiCategoryCard;
